import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { simplify } from 'app/shared/functions/meta.functions';
import { SearchMode } from '../../shared/enum/searchMode';

export function submit(form: NgForm, searchMode: SearchMode, request, router: Router, route: ActivatedRoute) {
  if (form.invalid) {
    return;
  }
  markFormAsTouched(form);
  router.navigate(['./list', searchMode], {
    relativeTo: route,
    queryParams: { request: JSON.stringify(simplify(request)) }
  });
}

export function markFormAsTouched(form: NgForm) {
  for (const control of Object.values(form.controls)) {
    control.markAsTouched();
  }
}
